<template>
  <div class="c-paragraph paragraph">
    <p
      v-html="data.content"
    ></p>
  </div>
</template>

<script>
export default {
  name: 'AppParagraph',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.paragraph {
  p {
    margin: 0;
    font-weight: 300;
    font-size: 15px;
    line-height: 1.3;
    text-align: center;

    @include mq(ipadP) {
      font-size: 18px;
    }

    &::v-deep {
      p {
        margin: 0;
      }
    }
  }
}
</style>

<style lang="scss">
.post {
  .c-paragraph.paragraph {
    p p {
      margin: 50px 0;
      line-height: 1.4;
    }

    h1, h2, h3, h4, h5 {
      font-family: $font-family-text;
      font-size: 20px;
      margin: 50px 0;

      @include mq(ipadP) {
        font-size: 24px;
      }
    }

    ul {
      margin: -10px 0;
      list-style: disc;
    }

    ol {
      margin: -10px 0;

      li {
        list-style-type: upper-roman;
      }
    }
  }
}

</style>
